<template>
  <div>
     <el-form
      ref="formRef"
      :model="searchForm"
      style="width:100%"
      :inline="true"
      :label-position="'right'"
    >
       <el-form-item>
        <el-input v-model="searchForm.shopAccount" clearable placeholder="请输入店铺账号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.shopName" clearable placeholder="请输入店铺名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.isBound" clearable placeholder="请选择是否绑定">
          <el-option label="已绑定" value="1"></el-option>
          <el-option label="未绑定" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.status" clearable placeholder="请选择店铺状态">
          <el-option label="正常" value="1"></el-option>
          <el-option label="冻结" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">查询</el-button>
        <el-button type="success" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>
    <!--element-ui table page-->
    <el-table
      :data="dataList"
      style="width: 100%"
      border
      v-loading="loading"
    >
      <el-table-column
        prop="shopAccount"
        label="店铺账号"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="shopName"
        label="店铺名称"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="shopAddress"
        label="店铺地址"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="isBound"
        label="是否绑定"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.isBound == 1 ? "已绑定" : "未绑定" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="boundTime"
        label="绑定时间"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="店铺状态"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.status == 1 ? "正常" : "冻结" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="created"
        label="创建时间"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="modified"
        label="更新时间"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
          <el-popconfirm
            title="确定删除吗？"
            @onConfirm="handleDelete(scope.row)"
          >
            <template slot="reference">
              <el-button type="text" size="small">删除</el-button>
            </template>
          </el-popconfirm>

          <el-popconfirm
            title="是否解绑？"
            @onConfirm="handleUnbound(scope.row)"
          >
            <template slot="reference">
              <el-button type="text" size="small" v-if="scope.row.isBound===1">解绑</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>

    <el-dialog
      title="更新/新增店铺"
      :visible.sync="dialogVisible"
      width="45%"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <el-form
        ref="formRef"
        :model="modelInfo"
        style="width:100%"
        :label-position="'right'"
        :inline="true"
        :rules="formRules"
        v-loading="formLoading"
      >
        <el-row>
          <el-col :span="12">
             <el-form-item label="店铺账号:" prop="shopAccount">
              <el-input v-model="modelInfo.shopAccount" clearable placeholder="请输入店铺账号" :disabled="!!modelInfo.id"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="店铺名称:" prop="shopName">
              <el-input v-model="modelInfo.shopName" clearable placeholder="请输入店铺名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="店铺地址" prop="shopAddress" style="width: 100%;">
              <el-input v-model="modelInfo.shopAddress" clearable placeholder="请输入店铺地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否绑定:" prop="isBound">
              <el-select :disabled="!!modelInfo.id" v-model="modelInfo.isBound" clearable placeholder="请选择是否绑定" style="width: 100%;">
                <el-option label="已绑定" :value="1"></el-option>
                <el-option label="未绑定" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="店铺状态:" prop="status">
              <el-select v-model="modelInfo.status" clearable placeholder="请选择店铺状态"  style="width: 100%;">
                <el-option label="正常" :value="1"></el-option>
                <el-option label="冻结" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { recoveryShopQuery,recoveryShopAccountExited,recoveryShopSave,recoveryShopUpdate,recoveryShopDelete,recoveryShopUnBound} from '../../api/api';
export default {
  data() {
    var shopAccountValidator = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入店铺账号'));
      } else {
        recoveryShopAccountExited({ shopAccount: value ,id: this.modelInfo.id}).then(res => {
          if (res.data.status == 100) {
            callback(new Error('店铺账号已存在'));
          } else {
            callback();
          }
        })
      }
    };
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      dataList: [],
      // dialog
      formLoading: false,
      dialogVisible: false,
      formRules: {
        shopAccount: [
          { required: true, message: '请输入店铺账号', trigger: 'blur' },
          { validator: shopAccountValidator, trigger: 'blur'}
        ],
        shopName: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' }
        ],
        isBound: [
          { required: true, message: '请选择是否绑定', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择店铺状态', trigger: 'blur' }
        ]
      },
      modelInfo: {
        status: 1,
        isBound: 0
      }

    }
  },
  mounted() {
    this.onload()
  },
  methods: {
    handleAdd() {
      this.modelInfo = {
        status: 1,
        isBound: 0
      }
      this.dialogVisible = true;
    },
    handleQuery() {
      this.searchForm.pageNum = 1
      this.onload()
    },
    async onload() {
      this.loading = true
      let res = await recoveryShopQuery(this.searchForm).finally(() => {
        this.loading = false
      })
      if (res.data.status == 100) {
        this.dataList = res.data.results.list
        this.searchForm.total = res.data.results.total;
      }
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.onload();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.onload();
    },
    handleEdit(row) {
      this.modelInfo = row
      this.dialogVisible = true
    },
    handleSave() {
      let _self = this;
      this.$refs.formRef.validate((valid) => {
        console.log(valid)
        if (valid) {
          if (this.modelInfo.id) {
            this.formUpdate()
          } else {
            this.formSave()
          }
        }
      })
    },
    async formSave() {
      this.formLoading = true
      let res = await recoveryShopSave(this.modelInfo).finally(() => {
        this.formLoading = false
      })
      if (res.data.status == 100) {
        this.dialogVisible = false
        this.onload()
      }else {
        this.$message.error(res.data.message)
      }
    },
    async formUpdate() {
      this.formLoading = true
      let res = await recoveryShopUpdate(this.modelInfo).finally(() => {
        this.formLoading = false
      })
      if (res.data.status == 100) {
        this.dialogVisible = false
        this.onload()
      } else {
        this.$message.error(res.data.message)
      }
    },
    async handleDelete(row) {
      this.loading = true
      let res = await recoveryShopDelete({ id: row.id }).finally(() => {
        this.loading = false
      })
      if (res.data.status == 100) {
        this.onload()
      } else {
        this.$message.error(res.data.message)
      }
    },
    async handleUnbound(row) {
      this.loading = true
      let res = await recoveryShopUnBound(row.id).finally(() => {
        this.loading = false
      })
      if (res.data.status == 100) {
        this.onload()
      } else {
        this.$message.error(res.data.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// recoveryShop.vue?28c16ab3